import update from 'immutability-helper'
import Inflection from 'inflection'
import * as React from 'react'
import { FormFor } from 'react-rails-form-helpers'
import { Address } from './Address'
import { AddressForm, AddressFormFields } from './Address/AddressForm'
import { Cart } from './Cart'
import { CustomerForm } from './Customer/CustomerForm'
import * as API from './lib/api'
import { Checkout } from './lib/checkout'
import { PurchaseOption } from './lib/purchase_option'
import { TaxInformation } from './lib/tax_information'
import { PaymentForm } from './PaymentForm'
import { PromoCodeForm } from './PromoCodeForm'
import { PurchaseOptionsSelect } from './PurchaseOptionsSelect'
import { TermsOfService } from './TermsOfService'
import { Testimonials } from './Testimonials'

declare var Routes: any
declare var Accept: any

export interface IProps {
  checkout: API.IMembershipCheckout
  authNet?: API.IAuthorizeNet
}

export interface IState {
  checkout: Checkout
  selectedPurchaseOptionName: API.PurchaseOptionNameType
  taxInformation: TaxInformation
  acceptJsId?: string
  paymentToken?: API.IPaymentToken
  paymentTokenErrors?: API.IAuthErrors[]
}

export class MembershipCheckoutForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { checkout: checkoutProps } = props
    const checkout = new Checkout(checkoutProps)
    const { billing_address: { country } } = checkout.cashier
    const acceptJsId = undefined

    let updatedCashier: API.ICashier

    const purchaseOption =
      checkout.purchaseOptions.find((o) => o.name == checkout.defaultPurchaseOption) || checkout.purchaseOptions[0]

    if (!purchaseOption) {
      throw new Error('No purchase option available!')
    }

    if (!country) {
      updatedCashier = update(checkout.cashier, {billing_address: {country: {$set: 'USA'}}})
      checkout.cashier = updatedCashier
    }

    this.state = {
      checkout,
      selectedPurchaseOptionName: purchaseOption.name,
      taxInformation: TaxInformation.placeholder,
      acceptJsId,
      paymentToken: undefined,
      paymentTokenErrors: undefined,
    }
  }

  public componentDidMount() {
    const {
      signedIn,
      trial,
      cashier: { billing_address: { country } },
    } = this.state.checkout

    if (signedIn && trial) {
      this.billingAddressChanged(AddressFormFields.Country, country)
    }
    this.updateTaxInformation()
    this.loadAcceptJs()
  }

  public componentWillUnmount() {
    this.unloadAcceptJs()
  }

  public applyPromoCode = (e: React.SyntheticEvent) => {
    const button = $(e.target)
    const form = button.parents('form').first()
    const { checkout } = this.state
    const { cashier } = checkout

    const updatedCashier = update(cashier, {errors: {$unset: ['promo_code']}})

    this.updateCashier(updatedCashier)

    $.post({
      url: Routes.igniter_membership_checkout_apply_promo_code_path(),
      data: form.serialize(),
      dataType: 'json',
    }).done(this.handlePromoCodeResponse)
  }

  public toggleUseDefaultBillingAddress = () => {
    const { checkout: { cashier } } = this.state

    const updatedCashier = update(
      cashier,
      {
        $toggle: ['use_default_billing_address'],
      },
    )

    this.updateCashier(updatedCashier, () => this.updateTaxInformation())
  }

  public billingAddressChanged = (field: keyof API.IAddress, value: string) => {
    const { checkout: { cashier } } = this.state
    const updatedCashier = update(
      cashier,
      {
        billing_address: { [field] : { $set: value } },
      },
    )

    this.updateCashier(updatedCashier, () => this.updateTaxInformation())
  }

  public cashierErrors() {
    const { checkout, taxInformation, paymentTokenErrors } = this.state
    const { cashier: { errors: cashierErrors } } = checkout
    const errorFields = Object.keys(cashierErrors)
    let errors = errorFields.map((field) => (
      <li key={field}>{field == 'base' ? '' : Inflection.titleize(field)} {cashierErrors[field]}</li>
    ))

    if (paymentTokenErrors && paymentTokenErrors.length > 0) {
      errors = errors.concat(
        paymentTokenErrors.map(({ code, text }) => (
          <li key={code}>Credit/Debit Card: {text}</li>
        )),
      )
    }

    errors = errors.concat(taxInformation.errors.map((e) => <li key={e}>{e}</li>))

    if (errors.length) {
      return (
        <div className="cashier-errors">
          <h2>Please correct the errors below to continue:</h2>
          <ul>
            {errors}
          </ul>
        </div>
      )
    }
  }

  public ctaText() {
    const { checkout } = this.state
    const { trial, signedIn } = checkout

    if (trial) {
      return 'Start My Trial'
    } else if (signedIn) {
      return 'Process My Order'
    }

    return  'Create My Account'
  }

  public render() {
    const {
      checkout,
      taxInformation,
      paymentToken,
    } = this.state
    const {
      cashier,
      signedIn,
      trial,
      trialLength,
      testimonials,
      purchaseOptions,
    } = checkout
    const selectedPurchaseOption = this.selectedPurchaseOption()
    const monthly: boolean = selectedPurchaseOption.name === 'monthly'
    const {
      customer,
      payment_type: paymentType,
      payment_profiles: paymentProfiles,
      payment_profile_id: selectedPaymentProfileId,
      credit_card: creditCard,
      terms_of_service: termsOfService,
    } = cashier
    const { current_membership_is_trial: currentMembershipIsTrial } = customer
    const {
      paymentDetails,
    } = selectedPurchaseOption
    const {
      membershipPlan,
      trialActivationPrice,
    } = selectedPurchaseOption
    const { code: planCode, totalIncludedItemsInTrial } = membershipPlan


    return (
      <div className="checkout membership-checkout">
        <div className="grid-x">
          <header className="cell">
            <h1>
              One More Step to {trial ? 'Start Your Free Trial' : 'Complete Your Purchase'}
            </h1>
          </header>
        </div>

        <div className="grid-container wide">
          <div className="grid-x">
            <div className="cell small-full mlarge-30 small-order-2 mlarge-order-1 checkout-form">
              <FormFor url={Routes.igniter_membership_checkout_path()} method="post" name="cashier">
                {this.cashierErrors()}

                {signedIn ? null : <CustomerForm customer={customer} />}

                {this.renderAddress()}

                <PaymentForm
                  paymentProfiles={paymentProfiles}
                  selectedPaymentProfileId={selectedPaymentProfileId}
                  creditCard={creditCard}
                  paymentType={paymentType}
                  paymentToken={paymentToken}
                >
                  <label htmlFor="purchase_option_select">
                    Choose the billing option that best fits your needs
                  </label>
                  <PurchaseOptionsSelect
                    purchaseOptions={purchaseOptions}
                    selectedPurchaseOptionName={selectedPurchaseOption.name}
                    onPurchaseOptionChange={this.onPurchaseOptionChange}
                  />
                </PaymentForm>

                {((currentMembershipIsTrial && planCode == membershipPlan.slug)|| trial) ? null : this.renderPromoCodeForm()}

                <TermsOfService
                  termsOfService={termsOfService}
                  totalIncludedItemsInTrial={totalIncludedItemsInTrial}
                  paymentDetails={paymentDetails}
                  taxInformation={taxInformation}
                  trial={trial}
                  trialLength={trialLength}
                  ctaText={this.ctaText()}
                  onCashierSubmit={this.onCheckoutFormSubmit}
                />

                {planCode ? <input type="hidden" name="plan_code" value={planCode} /> : null}
                <input type="hidden" name="monthly" value={monthly ? 1 : 0} />
                {trial ? <input type="hidden" name="trial" value={trial ? 1 : 0} /> : null}

              </FormFor>

              <Testimonials testimonials={testimonials} />
            </div>

            <div className="cell small-full mlarge-30 small-order-1 mlarge-order-2 order-preview">
              <Cart
                purchaseOption={selectedPurchaseOption}
                trialActivationPrice={trialActivationPrice}
                trial={trial}
                trialLength={trialLength}
                taxInformation={taxInformation}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  protected renderAddress() {
    const { checkout } = this.state
    const {
      cashier,
      stateSelectOptions,
      countrySelectOptions,
      signedIn,
    } = checkout
    const {
      billing_address: billingAddress,
      default_billing_address: defaultBillingAddress,
      use_default_billing_address: useDefaultBillingAddress,
      customer,
    } = cashier
    const title = signedIn ? 'Account Information' : 'Billing Address'

    if (useDefaultBillingAddress) {
      return (
        <Address
          address={defaultBillingAddress}
          signedIn={signedIn}
          customer={customer}
          addressType="billing"
          toggleUseDefaultBillingAddress={this.toggleUseDefaultBillingAddress}
        />
        )
    } else {
      return (
        <AddressForm
          address={billingAddress}
          addressType="billing"
          stateSelectOptions={stateSelectOptions}
          countrySelectOptions={countrySelectOptions}
          toggleUseDefaultBillingAddress={this.toggleUseDefaultBillingAddress}
          allowUsingDefault={!!defaultBillingAddress}
          onAddressChanged={this.billingAddressChanged}
          title={title}
        />
        ) }
  }

  protected renderPromoCodeForm() {
    const { checkout: { cashier } } = this.state
    const {
      allow_promo_code: allowPromoCode,
      promo_code: promoCode,
      errors,
    } = cashier

    if (!allowPromoCode) { return }

    return (
      <PromoCodeForm
        promoCode={promoCode}
        applyPromoCode={this.applyPromoCode}
        errors={errors.promo_code}
      />
      )
  }

  protected onPurchaseOptionChange = (purchaseOptionName: API.PurchaseOptionNameType) => {
    this.setState(
      {
        selectedPurchaseOptionName: purchaseOptionName,
      },
      () => this.updateTaxInformation(),
    )
  }

  protected updateCashier(updatedCashier: API.ICashier, callback?: () => void) {
    const { checkout } = this.state

    this.setState(
      {
        checkout: {
          ...checkout,
          cashier: updatedCashier,
        },
      },
      callback,
    )
  }

  protected async updateTaxInformation() {
    const { checkout } = this.state
    const {
      cashier,
    } = checkout
    const {
      billing_address: billingAddress,
      default_billing_address: defaultBillingAddress,
      use_default_billing_address: useDefaultBillingAddress,
      customer: { tax_exempt },
    } = cashier

    if (tax_exempt) {
      this.setState({ taxInformation: TaxInformation.no_tax })
      return
    } else {
      this.setState({ taxInformation: TaxInformation.placeholder })
    }

    const address = useDefaultBillingAddress ? defaultBillingAddress : billingAddress

    this.setState({
      taxInformation: await TaxInformation.calculateSalesTax({
        address,
        amount: this.selectedPurchaseOption().actualPrice(),
      }),
    })
  }

  protected selectedPurchaseOption(): PurchaseOption {
    const {
      selectedPurchaseOptionName,
      checkout: { purchaseOptions },
    } = this.state
    const option = purchaseOptions.find((o) => o.name == selectedPurchaseOptionName)

    if (!option) { throw new Error('Bad selected PurchaseOption!') }

    return option
  }

  protected handlePromoCodeResponse = (response: API.IPromoCodeResponse) => {
    const { checkout } = this.state
    const { cashier } = checkout
    const { checkout: checkoutResponse } = response
    const { purchase_options: purchaseOptions } = checkoutResponse
    const { promo_code, errors } = checkoutResponse.cashier

    let setErrors = {}
    if (errors.promo_code) {
      setErrors = { promo_code: { $set: errors.promo_code } }
    } else {
      setErrors = { $unset: ['promo_code'] }
    }

    const newPurchaseOptions = purchaseOptions.map((o) => new PurchaseOption(o))

    const updatedCashier = update(
      cashier,
      {
        promo_code: {$set: promo_code},
        errors: setErrors,
      },
    )

    this.setState({
      checkout: {
        ...checkout,
        cashier: updatedCashier,
        purchaseOptions: newPurchaseOptions,
      },
    })
  }

  protected loadAcceptJs() {
    if (!this.props.authNet) { return }

    const { authNet: { test_mode: authTestMode } } = this.props
    const { acceptJsId } = this.state

    if (!acceptJsId) {
      const acceptScriptUri = authTestMode ? 'https://jstest.authorize.net/v1/Accept.js' : 'https://js.authorize.net/v1/Accept.js'
      const scriptTag = document.createElement('script')
      scriptTag.id = 'acceptJs' + Math.random().toString(20).substr(2, 6)
      scriptTag.src = acceptScriptUri
      scriptTag.addEventListener('load', () => { this.setState({ acceptJsId: scriptTag.id }) })
      document.body.appendChild(scriptTag)
    }
  }

  protected unloadAcceptJs() {
    if (!this.props.authNet) { return }

    const { acceptJsId } = this.state

    if (acceptJsId) {
      const scriptTag = document.querySelector('#' + acceptJsId)
      if (scriptTag && scriptTag.parentNode)
        scriptTag.parentNode.removeChild(scriptTag)
    }
  }

  protected onCheckoutFormSubmit = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    const form = (event.currentTarget as HTMLButtonElement).form

    if (form === null) {
      throw new ReferenceError('button does not belong to form!')
    }

    if (form.elements['cashier_payment_profile_id']) {
      form.submit()
    }

    const fieldVal = (resource: string, fieldName: string): string => {
      return form.elements[`cashier_${resource}_${fieldName}`].value
    }

    if (form.elements['cashier_payment_type'].value === 'credit_card') {
      const creditCard = {
        card_number: fieldVal('credit_card', 'card_number'),
        exp_month: fieldVal('credit_card', 'exp_month'),
        exp_year: fieldVal('credit_card', 'exp_year'),
        cvv: fieldVal('credit_card', 'cvv'),
      }

      this.tokenizeWithAcceptJs(creditCard, () => {
        const { paymentTokenErrors } = this.state

        if (paymentTokenErrors && paymentTokenErrors.length == 0) {
          form.submit()
        } else {
          this.setState({
            paymentToken: undefined,
          })
        }
      })
    }
  }

  protected tokenizeWithAcceptJs(creditCard, callback: () => void) {
    if (!this.props.authNet) { return }

    const { public_client_key: publicClientKey, api_login_id: apiLoginId } = this.props.authNet

    const authData = {
      clientKey: publicClientKey,
      apiLoginID: apiLoginId,
    }

    const cardData = {
      cardNumber: creditCard.card_number,
      month: creditCard.exp_month,
      year: creditCard.exp_year,
      cardCode: creditCard.cvv,
    }

    const data = {
      authData: authData,
      cardData: cardData,
    }

    Accept.dispatchData(data, (response: any) => {
      this.handleTokenResponse(creditCard, response)
      this.forceUpdate(callback)
    })
  }

  protected handleTokenResponse(creditCard, tokenResponse: any) {
    if (tokenResponse.messages.resultCode === 'Error') {
      let i = 0
      const paymentTokenErrors: API.IAuthErrors[] = []
      while (i < tokenResponse.messages.message.length) {
        paymentTokenErrors.push({
          code: tokenResponse.messages.message[i].code,
          text: tokenResponse.messages.message[i].text,
        })
        i += 1
      }
      this.setState(
        {
          paymentToken: {
            dataDescriptor: '',
            dataValue: '',
            creditCard: creditCard,
          },
          paymentTokenErrors: paymentTokenErrors,
        },
      )
      window.scrollTo(0, 0)
    }
    else {
      this.setState(
        {
          paymentToken: {
            dataDescriptor: tokenResponse.opaqueData.dataDescriptor,
            dataValue: tokenResponse.opaqueData.dataValue,
            creditCard: creditCard,
          },
          paymentTokenErrors: [],
        },
      )
    }
  }
}
